export default {
  pageDesc: '拣选工位与复核工位数量一致，按任务流程类型分配给相应工位；一个工位对应一个播种架（4 行 × 9 列 ＝ 36 个播种框）',
  summary: '拣选工位 {pick} · 复核工位 {check}',
  refresh: '刷新状态',
  refreshed: '工位与播种架状态已刷新',
  flowTitle: '工位与流程分配',
  flowHint: '全流程工位可承接拣选 + 复核；仅拣选工位只承接拣选；仅复核工位只承接复核',
  colStation: '工位',
  colType: '类型',
  colWall: '播种架编号',
  colFlows: '承接流程类型',
  colOrders: '在架订单',
  colUsed: '占用框',
  colRunning: '当前作业',
  typePick: '拣选工位',
  typeCheck: '复核工位',
  flowAll: '全流程',
  flowPick: '拣选',
  flowChk: '复核',
  lampTitle: '播种架灯语',
  lampHint: '拣货侧 4 态 · 复核侧 3 态 · 两侧货架编号一致',
  lampOff: '灯不亮',
  lampOffDesc: '空闲，或已分配订单但尚未开始投放',
  lampGreen: '绿灯 · 待投放',
  lampGreenDesc: '系统下发投放指令后亮起，旁示该框应投件数',
  lampBlue: '蓝灯 END',
  lampBlueDesc: '该订单已全部投完，等待推送至复核侧',
  lampRed: '红灯 FF',
  lampRedDesc: '已推送至复核侧，等待复核',
  lampNotePickLabel: '拣货侧',
  lampNotePick: '：灯不亮＝空闲或已分配订单　·　绿灯＋件数＝待投放　·　蓝灯 END＝该行已投完　·　红灯 FF＝已推至复核侧。',
  lampNoteCheckLabel: '复核侧',
  lampNoteCheck: '：灯不亮＝空闲　·　红灯＝待复核　·　绿灯＝复核完成、待放回；复核侧灯只显示颜色，不显示数字与字母。',
  lampNoteCode: '播种框编号',
  lampNoteCodeEx: 'B103A-19-A9',
  lampNoteCodeRule: '＝ 工位 B103A · 第 19 面播种架 · A 行第 9 列。',
  pickSection: '拣选工位',
  pickSectionHint: '每张卡 ＝ 一个工位 ＋ 一个播种架；卡内下方为该架绑定的订单进度',
  checkSection: '复核工位',
  checkSectionHint: '复核侧只显示灯色；红灯即待复核订单',
  orderCount: '{n} 个订单',
  wallMeta: '播种架 {code} · {area}',
  usedFramesLabel: '占用框',
  freeFramesLabel: '空闲',
  freeFramesUnit: '框',
  occupyRateLabel: '占用率',
  lampPickGreen: '绿 待投放',
  lampPickBlue: '蓝 END 已投完',
  lampPickRed: '红 FF 已推复核侧',
  lampCheckRed: '红 待复核',
  lampCheckGreen: '绿 已复核待放回',
  lampIdle: '灯不亮＝空闲 / 已分配',
  framePos: '框 {pos}',
  skuCount: '{n} SKU',
  qtyProgress: '{done}/{need}',
  badgePicking: '拣选中',
  badgeComplete: '齐套',
  badgePendingCheck: '待复核',
  badgeChecked: '已复核',
  cellIdle: '空闲',
  cellTip: '{station} · {code}-{pos} · {detail}',
  cellTipBusy: '{order} · {skuCount} 个 SKU · {done}/{need} 件',
  cellTipOrder: '{order}',
  orderBound: '已绑定',
}
